/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_OkInputs */

const en_mk_tut_daftar_ok = /** @type {(inputs: Mk_Tut_Daftar_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You land on the “Create workspace” page.`)
};

const id_mk_tut_daftar_ok = /** @type {(inputs: Mk_Tut_Daftar_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda berpindah ke halaman "Buat workspace".`)
};

/**
* | output |
* | --- |
* | "You land on the “Create workspace” page." |
*
* @param {Mk_Tut_Daftar_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_ok = /** @type {((inputs?: Mk_Tut_Daftar_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_ok(inputs)
	return en_mk_tut_daftar_ok(inputs)
});